import { Star, Quote } from "lucide-react";
import { REVIEWS } from "@/lib/reviews";

export default function Reviews() {
  return (
    <section id="avis" className="py-20 sm:py-24 bg-[#F5F7FA] scroll-mt-24" data-testid="reviews-section">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-14">
          <p className="text-xs uppercase tracking-[0.28em] font-semibold text-[#005BBB] mb-3">Avis clients</p>
          <h2 className="font-display text-3xl sm:text-4xl lg:text-5xl font-bold text-[#001B35]">
            Ils nous ont fait <span className="text-[#005BBB]">confiance</span>
          </h2>
          <div className="mt-5 w-16 h-1 bg-[#005BBB] mx-auto rounded-full" />

          <div className="mt-7 inline-flex items-center gap-3 bg-white rounded-full px-5 py-2.5 shadow-sm border border-gray-100">
            <div className="flex">
              {[...Array(5)].map((_, i) => (
                <Star key={i} className="w-4 h-4 fill-[#FFB400] text-[#FFB400]" />
              ))}
            </div>
            <span className="font-bold text-[#001B35]">5,0 / 5</span>
            <span className="text-xs text-gray-500 uppercase tracking-wider">Avis Google</span>
          </div>
        </div>

        <div className="grid md:grid-cols-2 gap-7 max-w-4xl mx-auto">
          {REVIEWS.map((r, i) => (
            <article
              key={r.author}
              data-testid={`review-card-${i}`}
              className="rm-card bg-white rounded-2xl border border-gray-100 p-7 shadow-[0_4px_20px_-12px_rgba(0,27,53,0.15)] relative"
            >
              <Quote className="absolute top-5 right-5 w-10 h-10 text-[#005BBB]/10" />
              <div className="flex items-center gap-3 mb-4">
                <div className="w-12 h-12 rounded-full bg-gradient-to-br from-[#005BBB] to-[#001B35] flex items-center justify-center text-white font-display font-bold text-lg">
                  {r.author.charAt(0).toUpperCase()}
                </div>
                <div>
                  <p className="font-display font-bold text-[#001B35]">{r.author}</p>
                  <p className="text-xs text-gray-500">Avis Google • {r.date}</p>
                </div>
              </div>

              <div className="flex mb-3">
                {[...Array(r.rating)].map((_, i) => (
                  <Star key={i} className="w-4 h-4 fill-[#FFB400] text-[#FFB400]" />
                ))}
              </div>

              <p className="text-sm text-gray-700 leading-relaxed italic">
                « {r.text} »
              </p>

              <div className="mt-5 pt-4 border-t border-gray-100 flex items-center gap-2">
                <svg className="w-4 h-4" viewBox="0 0 24 24" aria-hidden="true">
                  <path fill="#4285F4" d="M22.56 12.25c0-.78-.07-1.53-.2-2.25H12v4.26h5.92c-.26 1.37-1.04 2.53-2.21 3.31v2.77h3.57c2.08-1.92 3.28-4.74 3.28-8.09z"/>
                  <path fill="#34A853" d="M12 23c2.97 0 5.46-.98 7.28-2.66l-3.57-2.77c-.98.66-2.23 1.06-3.71 1.06-2.86 0-5.29-1.93-6.16-4.53H2.18v2.84C3.99 20.53 7.7 23 12 23z"/>
                  <path fill="#FBBC05" d="M5.84 14.09c-.22-.66-.35-1.36-.35-2.09s.13-1.43.35-2.09V7.07H2.18C1.43 8.55 1 10.22 1 12s.43 3.45 1.18 4.93l2.85-2.22.81-.62z"/>
                  <path fill="#EA4335" d="M12 5.38c1.62 0 3.06.56 4.21 1.64l3.15-3.15C17.45 2.09 14.97 1 12 1 7.7 1 3.99 3.47 2.18 7.07l3.66 2.84c.87-2.6 3.3-4.53 6.16-4.53z"/>
                </svg>
                <span className="text-xs uppercase tracking-wider text-gray-500 font-semibold">{r.source}</span>
              </div>
            </article>
          ))}
        </div>

        <p className="mt-10 text-center text-sm text-gray-600">
          Vous aussi, partagez votre expérience sur notre fiche Google ⭐
        </p>
      </div>
    </section>
  );
}
